<div class="navbar" [ngClass]="{'remove-navbar': ($sticky | async) === false }">
  <div [ngStyle]="{'visibility': $logoPart | async}" class="navbar__logo">
    <app-logo [logoLink]="logoLink" [logo]="logo" [logoName]="logoName"></app-logo>
    <p class="slogan mobile-slogan" *ngIf="logoSloganMobile">{{ logoSloganMobile }}</p>
    <p class="slogan desktop-slogan" *ngIf="logoSlogan">{{ logoSlogan }}</p>
  </div>
  <div class="navbar__service-links" *ngIf="links && links.length">
    <div  class="normal-menu" [ngClass]=" ($open | async)? 'show': 'hide'">
      <ul>
        <li *ngFor="let link of links" [title]="link?.textOver"><a [ngClass]="{'special': link.special}" smNavigate="{{ link.link }}"><span (click)="openMenu()">{{ link.text }}</span></a></li>
      </ul>
    </div>
    <app-hamburger-menu (click)="openMenu()"></app-hamburger-menu>
  </div>
</div>
